import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {SessionService} from './session.service';

class InterceptingHandler implements HttpHandler {

  constructor(private backend: HttpBackend, private sess: SessionService) {
  }

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.backend.handle(req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + this.sess.getAccessToken())
    }));
  }
}

@Injectable()
export class JwtAuthClient extends HttpClient {
  constructor(backend: HttpBackend, private sess: SessionService) {
    super(new InterceptingHandler(backend, sess));
  }
}
